import { API_BASE_URL } from "../api/constants";

/**
 * Normaliza lo que puede venir del backend (URL, ruta, base64 crudo o data URL) a algo usable en <img src>.
 */
export const resolveImageRef = (value) => {
  if (!value || typeof value !== "string") return "";
  const source = value.trim().replace(/\\/g, "/");
  if (!source || source === "string") return "";
  if (source.startsWith("blob:")) return source;
  if (source.startsWith("data:image")) return source;
  if (source.startsWith("base64,")) return `data:image/jpeg;${source}`;

  const compact = source.replace(/\r?\n/g, "");
  if (compact.startsWith("/9j/")) {
    return `data:image/jpeg;base64,${compact}`;
  }
  if (compact.startsWith("iVBOR")) {
    return `data:image/png;base64,${compact}`;
  }
  if (compact.startsWith("R0lGOD")) {
    return `data:image/gif;base64,${compact}`;
  }
  if (compact.startsWith("UklGR")) {
    return `data:image/webp;base64,${compact}`;
  }
  if (/^[A-Za-z0-9+/=_-]+$/.test(compact) && compact.length > 100) {
    return `data:image/jpeg;base64,${compact}`;
  }
  if (/^https?:\/\//i.test(source)) return source;
  if (source.startsWith("//")) return `https:${source}`;

  let apiOrigin = API_BASE_URL;
  try {
    apiOrigin = new URL(API_BASE_URL).origin;
  } catch (error) {
    apiOrigin = API_BASE_URL.replace(/\/+$/, "");
  }

  if (source.startsWith("/")) return `${apiOrigin}${source}`;
  return `${apiOrigin}/${source}`;
};
